document.addEventListener('DOMContentLoaded', function() {
  var langBtns = document.querySelectorAll('.lang-toggle-btn');
  langBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = btn.closest('form');
      var lang = btn.classList.contains('left') ? 'tr' : 'en';
      form.querySelector('[name=language_code]').value = lang;
      form.submit();
    });
  });
});
